import { Component } from 'react';

/**
 * Component for displaying the Adobe Messaging Client.
 *
 * This component displays the Adobe Messaging Client (Jarvis).
 *
 * @component
 * @example
 *
 * return (
 *   <JarvisChat />
 * )
 */
class JarvisChat extends Component {
  componentDidMount() {

    const adobeIDInitializedCheck = ()=>{
      if (window.adobeIMS && Boolean(window.adobeIMS.getAccessToken())) {
        loadJarvisScript();
        return null;
      }
      else {
        window.setTimeout(adobeIDInitializedCheck, 300);
      }
    }
    // Load the Jarvis Script
    const loadJarvisScript = () => {
      // Jarvis Configuration
      window.jarvisConfig = {
        appid: 'cbconnection',
        appver: '1.0',
        language: 'en',
        region: 'us',
        accessToken: window.adobeIMS.getAccessToken().token ? `Bearer ${window.adobeIMS.getAccessToken().token}` : null,
        env: window.apcConfig.jarvis.environment.includes('stage-client') ? 'stage' : 'prod',
        clientId: window.adobeIMS.adobeid.client_id,
        cookiesEnabled: false,
        callbacks: {
          signInProvider: null,
          initCallback: null,
          initErrorCallback: null,
          analyticsCallback: null,
          chatStateCallback: null,
        },
      };

      // Inject Jarvis CSS styles
      const link = document.createElement('link');
      link.href = window.apcConfig.jarvis.css;
      link.type = 'text/css';
      link.rel = 'stylesheet';
      document.getElementsByTagName('head')[0].appendChild(link);

      // Inject Jarvis JS
      const jarvisLib = document.createElement('script');
      jarvisLib.src = window.apcConfig.jarvis.environment;
      jarvisLib.id = 'jarvis-script';
      document.body.appendChild(jarvisLib);

      // Once the script is loaded, run the init command.
      jarvisLib.addEventListener('load', () => {
        window.AdobeMessagingExperienceClient.initialize(window.jarvisConfig);
      });
    };

    // Check if Adobe ID initialized, if not, wait for it.
     adobeIDInitializedCheck();
    
  }

  // Because the Jarvis chat renders itself, we do not need to return anything.
  render() {
    return null;
  }
}

export default JarvisChat;
